import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { InstantTradeBonusComponent } from "@modules/shared/components/instant-trade-bonus/instant-trade-bonus.component";

const components = [InstantTradeBonusComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class InstantTradeBonusModule {}
